import { all } from "redux-saga/effects";
import Auth from "./Auth";
import Lookup from "./Lookup";
export default function* rootSaga(getState) {
  yield all([Auth(), Lookup()]);
}
